/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_NevermindInputs */

const en_dialog_nevermind = /** @type {(inputs: Dialog_NevermindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nevermind`)
};

const es_dialog_nevermind = /** @type {(inputs: Dialog_NevermindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No importa`)
};

/**
* | output |
* | --- |
* | "Nevermind" |
*
* @param {Dialog_NevermindInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_nevermind = /** @type {((inputs?: Dialog_NevermindInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_NevermindInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_nevermind(inputs)
	return en_dialog_nevermind(inputs)
});